// NGRX
import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
// CRUD
import { Pharmacy } from '../_models/pharmacy.model';
// Models
import { QueryParamsModel } from '../../_base/crud';

export enum PharmacyActionTypes {
  AllPharmaciesRequested = '[Pharmacies] All Pharmacies Requested',
  AllPharmaciesLoaded = '[Pharmacies] All Pharmacies Loaded',
  PharmacyOnServerCreated = '[Pharmacies] Pharmacy On Server Created',
  PharmacyCreated = '[Pharmacies] Pharmacy Created',
  PharmacyOnServerUpdated = '[Pharmacies] Pharmacy On Server Updated',
  PharmacyUpdated = '[Pharmacies] Pharmacy Updated',
  PharmacyOnServerDeleted = '[Pharmacies] Pharmacy On Server Deleted',
  PharmacyDeleted = '[Pharmacies] Pharmacy Deleted',
  PharmaciesPageRequested = '[Pharmacies] Pharmacies Page Requested',
  PharmaciesPageLoaded = '[Pharmacies] Pharmacies Page Loaded',
  PharmaciesPageCancelled = '[Pharmacies] Pharmacies Page Cancelled',
  PharmaciesPageToggleLoading = '[Pharmacies] Pharmacies Page Toggle Loading',
  PharmaciesActionToggleLoading = '[Pharmacies] Pharmacies Action Toggle Loading',
  ThrowPharmacyError = '[Pharmacies] Throw Error',
  FirePharmacySuccess = '[Pharmacies] Fire Success',
}

export class PharmacyOnServerCreated implements Action {
  readonly type = PharmacyActionTypes.PharmacyOnServerCreated;
  constructor(public payload: { pharmacy: Pharmacy }) {}
}

export class PharmacyCreated implements Action {
  readonly type = PharmacyActionTypes.PharmacyCreated;
  constructor(public payload: { pharmacy: Pharmacy }) {}
}

export class ThrowPharmacyError implements Action {
  readonly type = PharmacyActionTypes.ThrowPharmacyError;
  constructor(public payload: { error: any }) {}
}

export class FirePharmacySuccess implements Action {
  readonly type = PharmacyActionTypes.FirePharmacySuccess;
  constructor(public payload: { action_type: string }) {}
}

export class PharmacyOnServerUpdated implements Action {
  readonly type = PharmacyActionTypes.PharmacyOnServerUpdated;
  constructor(
    public payload: {
      partialPharmacy: Update<Pharmacy>;
      pharmacy: Pharmacy;
    },
  ) {}
}
export class PharmacyUpdated implements Action {
  readonly type = PharmacyActionTypes.PharmacyUpdated;
  constructor(
    public payload: {
      partialPharmacy: Update<Pharmacy>;
      pharmacy: Pharmacy;
    },
  ) {}
}

export class PharmacyOnServerDeleted implements Action {
  readonly type = PharmacyActionTypes.PharmacyOnServerDeleted;
  constructor(public payload: { id: number }) {}
}

export class PharmacyDeleted implements Action {
  readonly type = PharmacyActionTypes.PharmacyDeleted;
  constructor(public payload: { id: number }) {}
}

export class PharmaciesPageRequested implements Action {
  readonly type = PharmacyActionTypes.PharmaciesPageRequested;
  constructor(public payload: { page: QueryParamsModel }) {}
}

export class PharmaciesPageLoaded implements Action {
  readonly type = PharmacyActionTypes.PharmaciesPageLoaded;
  constructor(
    public payload: { pharmacies: Pharmacy[]; totalCount: number; page: QueryParamsModel },
  ) {}
}

export class PharmaciesPageCancelled implements Action {
  readonly type = PharmacyActionTypes.PharmaciesPageCancelled;
}

export class PharmaciesPageToggleLoading implements Action {
  readonly type = PharmacyActionTypes.PharmaciesPageToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class PharmaciesActionToggleLoading implements Action {
  readonly type = PharmacyActionTypes.PharmaciesActionToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export type PharmacyActions =
  | PharmacyCreated
  | PharmacyUpdated
  | PharmacyDeleted
  | PharmacyOnServerCreated
  | PharmacyOnServerUpdated
  | PharmacyOnServerDeleted
  | PharmaciesPageLoaded
  | PharmaciesPageCancelled
  | PharmaciesPageToggleLoading
  | PharmaciesPageRequested
  | ThrowPharmacyError
  | FirePharmacySuccess
  | PharmaciesActionToggleLoading;
